import { Eyebrow } from "@/components/Reveal";

export const SectionHeading = ({ eyebrow, title, accent, description, align = "left", light = false }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className={`font-display text-4xl sm:text-5xl font-medium leading-[1.05] tracking-tight mt-4 ${light ? "text-[#FFFFFF]" : "text-[#2C2A29]"}`}>
      {title} {accent && <span className="italic text-[#9E8773]">{accent}</span>}
    </h2>
    {description && (
      <p className={`mt-5 text-base sm:text-lg font-light leading-relaxed ${light ? "text-[#C9C2B6]" : "text-[#5E5A54]"}`}>
        {description}
      </p>
    )}
  </div>
);
